(() => {
  'use strict';

  const config = window.TraumkunstAnalytics || {};
  const endpoint = typeof config.endpoint === 'string' ? config.endpoint.trim() : '';

  if (!endpoint || endpoint.includes('YOUR_PROJECT')) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (new URLSearchParams(window.location.search).has('preview_theme_id')) return;

  const payload = {
    event_id: crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    path: window.location.pathname || '/',
    page_type: config.pageType || null,
    product_handle: config.productHandle || null,
    product_title: config.productTitle || null,
    referrer_host: null,
    utm_source: null,
    utm_medium: null,
    utm_campaign: null
  };

  try {
    if (document.referrer) {
      const ref = new URL(document.referrer);
      if (ref.hostname && ref.hostname !== window.location.hostname) {
        payload.referrer_host = ref.hostname.replace(/^www\./, '');
      }
    }
  } catch (_) {}

  try {
    const params = new URLSearchParams(window.location.search);
    payload.utm_source = params.get('utm_source');
    payload.utm_medium = params.get('utm_medium');
    payload.utm_campaign = params.get('utm_campaign');
  } catch (_) {}

  const body = JSON.stringify(payload);

  const send = () => {
    fetch(endpoint, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      cache: 'no-store',
      keepalive: true,
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body
    }).catch(() => {});
  };

  if (document.readyState === 'complete') {
    send();
  } else {
    window.addEventListener('load', send, { once: true });
  }
})();
